const SHOP = window.GLOBAL.shop;
const STORE_ACCESS_TOKEN = window.GLOBAL.storefrontAccessToken;

// Products API

/**
 * Get Products by list of ids
 *
 * @param {string[]} ids A list of ids. Example value: ["63182131313", "63182131312"]
 * @param {string | null} nodes The nodes contained in ProductEdge. Example value: 'title handle'
 *
 */
async function getProductsByIds(ids, nodes) {
    try {
        if (ids && ids.length === 0) return;

        const query = `query {
                            nodes(ids: ${JSON.stringify(ids.map(e => `gid://shopify/Product/${e}`))}) {
                                id
                                ... on Product {
                                    ${nodes || ''}
                                }
                            }
                        }`

        const response = await fetch(
            `https://${SHOP}/api/2024-04/graphql.json`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-Shopify-Storefront-Access-Token": STORE_ACCESS_TOKEN,
                },
                body: JSON.stringify({ query }),
            }
        );

        const responseData = await response.json();
        if (responseData.errors && responseData.errors.length) {
            throw new Error(JSON.stringify(responseData.errors));
        }
        let products = []
        if (responseData && responseData.data) {
            products = responseData.data.nodes.filter(Boolean);
        }

        return { result: true, data: products };
    } catch (error) {
        console.error("ERR", error);
        return { result: false, data: null, error };
    }
}
